import { render, staticRenderFns } from "./CommitmentOfTraders.vue?vue&type=template&id=37552c76&scoped=true&"
import script from "./CommitmentOfTraders.vue?vue&type=script&lang=js&"
export * from "./CommitmentOfTraders.vue?vue&type=script&lang=js&"
import style0 from "./CommitmentOfTraders.vue?vue&type=style&index=0&id=37552c76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37552c76",
  null
  
)

export default component.exports